import Route from "@ember/routing/route";
import { service } from "@ember/service";
import { task } from "ember-concurrency";

export default class ColocationRacksRoute extends Route {
  @service availableServices;

  beforeModel() {
    this.availableServices.requireAccessTo(this, "bare-metal");
  }

  model() {
    let { project } = this.modelFor("organization");

    return { project, loadData: this.loadData };
  }

  loadData = task(async () => {
    return this.context.project.colocationRacks;
  });
}
